export function getFromMapOrDefault(map, key, defaultValue) {
  // Check if the key exists in the map
  if (map.hasOwnProperty(key)) {
    return map[key];
  }
  return defaultValue;
}